"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletLoginAPI = void 0;
var api_client_1 = __importDefault(require("../api-client"));
var wallet_login_constants_1 = require("./wallet-login.constants");
var AuthTokenService_1 = __importDefault(require("../../utils/AuthTokenService"));
var WalletLoginAPI = /** @class */ (function () {
    function WalletLoginAPI() {
    }
    WalletLoginAPI.loginSTUser = function (address) {
        return api_client_1.default.post(wallet_login_constants_1.WALLET_LOGIN_API_URLS.ST_USER_LOGIN, { address: address }).then(function (response) {
            var _a;
            var jwtPair = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.tokens;
            if (typeof window === 'undefined') {
                return response;
            }
            if ((jwtPair === null || jwtPair === void 0 ? void 0 : jwtPair.refresh) && (jwtPair === null || jwtPair === void 0 ? void 0 : jwtPair.access)) {
                AuthTokenService_1.default.setToken('access', jwtPair.access);
                AuthTokenService_1.default.setToken('refresh', jwtPair.refresh);
            }
            else {
                AuthTokenService_1.default.removeToken('access');
                AuthTokenService_1.default.removeToken('refresh');
            }
            return response;
        });
    };
    return WalletLoginAPI;
}());
exports.WalletLoginAPI = WalletLoginAPI;
